import { UsersAction } from './../../../state-management/users/users.actions';
import { UsersEffects } from './../../../state-management/users/users.effects';
import { Injectable } from '@angular/core';
import { ConnectionStatus } from 'botframework-directlinejs';
import { ChatBotService } from './../chat-bot.component.service';

import { Observable ,  Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '../../../interfaces/app-state.interface';

@Injectable()
export class BotService {

    public queueConversation$: Observable<any>;
    public onLoading: boolean = true;
    public renewTokenInterval: any;
    public startedConversation: boolean = false;

    private directLine;
    private queueConversation: any[] = [];
    private queueConversationSubject: Subject<any>;
    private loadingTimeOut;

    constructor(
        private cBService: ChatBotService,
        private store: Store<AppState>,
        private userEffects: UsersEffects,
    ) {
        this.queueConversationSubject = new Subject();
        this.queueConversation$ = this.queueConversationSubject.asObservable();
        this.startManageConversationQueue();
    }

    /**
     * inicia uma conversa
     */
    public startConversation() {
        // Promise
        this.cBService.startNewConversation()
            .then((directLine: any) => {
                this.directLine = directLine;
                this.monitoreStatus();
                this.receiveMessages();
                this.renewToken();
            })
            .catch((err) => {
                this.queueConversation.push({
                    attachments: [{
                        content: err,
                        contentType: 'application/reconnect.text',
                    }],
                });
            });
    }

    public renewToken() {
        // faz um request para renovar o token a cada 15min
        this.renewTokenInterval = setInterval(() => {

            // Promise
            this.cBService.renewToken()
                .then((reconnect: any) => {
                    this.directLine.reconnect(reconnect);
                })
                .catch((err) => {
                    this.queueConversation.push({
                        attachments: [{
                            content: err,
                            contentType: 'application/reconnect.text',
                        }],
                    });
                    clearInterval(this.renewTokenInterval);
                });
        }, 900000);
    }

    /**
     * Envia mensagem
     * @param messageText Texto da mensagem
     */
    public sendMessage(messageText: string) {

        this.startloading();

        // obj para enviar msg, com id e nome do usuario atual
        const coversation = {
            from: {
                id: this.cBService.user.userId,
                name: this.cBService.user.name,
            },
            type: 'message',
            text: messageText,
        };

        this.directLine
            .postActivity(coversation)
            .subscribe(
                (id) => id,
                (error) => error,
            );
    }

    /**
     * Recebe mensagens do bot
     */
    private receiveMessages() {
        this.directLine.activity$
            .filter((act) => act && ((act.type === 'message') && (act.from.id !== this.cBService.user.userId)))
            .subscribe((res) => {
                this.queueConversation.push(res);
            });
    }

    /**
     * Gerencia a fila de menssagens enviadas do bot para o usuario e desabilita o loading
     */
    private startManageConversationQueue() {
        setInterval(() => {
            if (this.queueConversation.length > 0) {
                this.endLoading();
                this.queueConversationSubject.next(this.queueConversation.splice(0, 1)[0]);
            }
        }, 3000);
    }

    /**
     * Monitora o status de conexão do socket aberto com o bot
     */
    private monitoreStatus() {
        this.directLine.connectionStatus$
            .subscribe((connectionStatus) => {
                switch (connectionStatus) {
                    // the status when the DirectLine object is first created/constructed
                    case ConnectionStatus.Uninitialized:
                        break;
                    // currently trying to connect to the conversation
                    case ConnectionStatus.Connecting:
                        break;
                    // successfully connected to the converstaion. Connection is healthy so far as we know.
                    case ConnectionStatus.Online:
                        break;
                    // last operation errored out with an expired token. Your app should supply a new one.
                    case ConnectionStatus.ExpiredToken:
                        this.queueConversation.push({
                            attachments: [{
                                content: 'Token de acesso expirado',
                                contentType: 'application/reconnect.text',
                            }],
                        });
                        break;
                    // the initial attempt to connect to the conversation failed. No recovery possible.
                    case ConnectionStatus.FailedToConnect:
                        break;
                    // the bot ended the conversation
                    case ConnectionStatus.Ended:
                        break;
                }
            });
    }

    /**
     * habilita o loading apos 2 segundos sem resposta do server
     */
    private startloading() {
        this.loadingTimeOut = setTimeout(() => {
            this.onLoading = true;
        }, 3000);
    }

    /**
     * desabilita o loading caso tenha menssagens na fila aguardando para serem exibidas
     */
    private endLoading() {
        clearTimeout(this.loadingTimeOut);
        this.onLoading = false;
    }
}
